import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, RouterModule } from '@angular/router';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './core/auth/error.interceptor';
import { CustomPreloading } from './core/services/customPreloading.service';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeSp from '@angular/common/locales/es';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TimeagoModule } from 'ngx-timeago';
import { TooltipModule } from 'ng2-tooltip-directive';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from './shared/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ProgressBarModule } from 'angular-progress-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { HotToastModule } from '@ngneat/hot-toast';
import { TitleService } from './core/services/title.service';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getLocalizedPaginatorIntl } from './shared/paginatorIntl';

const routerConfig: ExtraOptions = {
    preloadingStrategy: CustomPreloading,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
};

export function createTranslateLoader(http: HttpClient): any {
    return new TranslateHttpLoader(
        http,
        `/assets/i18n/`,
        ".json"
      );
}

const lang = localStorage.getItem('language');
registerLocaleData(
    lang == 'es'
        ? localeSp
        : lang == 'fr'
        ? localeFr
        : lang == 'de'
        ? localeDe
        : localeEn
);

@NgModule({
    declarations: [AppComponent],
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        //Toast
        HotToastModule.forRoot({
            position: 'top-right',
            duration: 3000, 
        }),

        TimeagoModule.forRoot(),
        TooltipModule,
        InfiniteScrollModule,
        NgCircleProgressModule.forRoot({
            radius: 15,
            space: -5,
            outerStrokeGradient: false,
            outerStrokeWidth: 5,
            outerStrokeColor: 'var(--partnerReach-primary)',
            innerStrokeColor: '#e7e8ea',
            innerStrokeWidth: 5,
            title: 'UI',
            animateTitle: false,
            animationDuration: 300,
            showTitle: false,
            showSubtitle: false,
            showUnits: false,
            showBackground: false,
            clockwise: false,
            startFromZero: false,
        }),
        MatIconModule,
        SharedModule,
        MatDialogModule,
        MatButtonModule,
        ProgressBarModule,
        MatMenuModule,
        MatSelectModule,
        MatPasswordStrengthModule.forRoot(),
    ],
    exports: [],
    bootstrap: [AppComponent],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        {
            provide: LOCALE_ID,
            useValue:
                lang == 'es'
                    ? 'es-ES'
                    : lang == 'fr'
                    ? 'fr-FR'
                    : lang == 'de'
                    ? 'de-DE'
                    : 'en-EN',
        },
        TitleService,
        { provide: MatPaginatorIntl, useValue: getLocalizedPaginatorIntl()}
    ],
})
export class AppModule {}
